import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { imageBaseURL } from '../../Api';

const DetailImage = () => {
  const location = useLocation();
  const images = location.state?.images || [];
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (img) => {
    setSelectedImage(`${imageBaseURL}${img}`);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  return (
    <div className="detail-images-page">
      <div className="image-gallery">
        {images.length > 0 ? (
          images.map((img, index) => (
            <img
              key={index}
              src={`${imageBaseURL}${img}`}
              alt={`Bukti Pengerjaan ${index + 1}`}
              onClick={() => handleImageClick(img)} // Set selected image on click
              className="gallery-image"
            />
          ))
        ) : (
          <p>No images available</p>
        )}
      </div>

      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <img src={selectedImage} alt="Zoomed" className="lightbox-image" />
        </div>
      )}
    </div>
  );
};

export default DetailImage;
